import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiKey } from '@/stores/apiKey.store';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export default function SSOCallbackPage() {
    const navigate = useNavigate();
    const setKey = useApiKey((s) => s.setKey);
    const [status, setStatus] = useState<'parsing' | 'success' | 'error'>('parsing');

    useEffect(() => {
        // Parse fragment: #key=stm_...&exp=1730000000
        const hash = window.location.hash.startsWith('#')
            ? window.location.hash.slice(1)
            : window.location.hash;
        const params = new URLSearchParams(hash);
        const key = params.get('key');
        const exp = params.get('exp');

        if (!key || !key.startsWith('stm_')) {
            setStatus('error');
            return;
        }

        setKey(key, exp ? parseInt(exp, 10) : undefined);
        // Strip fragment from URL (don't leave key in history)
        history.replaceState(null, '', '/');
        setStatus('success');
        const t = setTimeout(() => navigate('/', { replace: true }), 600);
        return () => clearTimeout(t);
    }, [navigate, setKey]);

    return (
        <div className="min-h-[calc(100vh-56px)] flex items-center justify-center px-6">
            <div className="text-center max-w-md w-full">
                {status === 'parsing' && (
                    <>
                        <Loader2 className="h-8 w-8 mx-auto mb-3 animate-spin" style={{ color: 'var(--accent)' }} />
                        <p className="text-sm font-medium mb-1" style={{ color: 'var(--ink)' }}>Menyambungkan ke SatuTim…</p>
                        <p className="text-xs" style={{ color: 'var(--muted)' }}>Connecting to API</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <div
                            className="w-10 h-10 mx-auto mb-3 rounded-full flex items-center justify-center"
                            style={{ backgroundColor: 'var(--accent-bg)' }}
                        >
                            <CheckCircle2 className="h-5 w-5" style={{ color: 'var(--accent)' }} />
                        </div>
                        <p className="text-sm font-semibold mb-1" style={{ color: 'var(--ink)' }}>API key tersinkron</p>
                        <p className="text-xs" style={{ color: 'var(--muted)' }}>Mengarahkan ke playground…</p>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <div
                            className="w-10 h-10 mx-auto mb-3 rounded-full flex items-center justify-center"
                            style={{ backgroundColor: 'var(--err-bg)' }}
                        >
                            <XCircle className="h-5 w-5" style={{ color: 'var(--err)' }} />
                        </div>
                        <p className="text-sm font-semibold mb-1" style={{ color: 'var(--ink)' }}>Gagal sinkron key</p>
                        <p className="text-xs mb-4" style={{ color: 'var(--muted)' }}>URL callback tidak valid atau expired.</p>
                        <a
                            href="/"
                            className="inline-flex items-center gap-1 text-sm font-medium transition-opacity hover:opacity-80"
                            style={{ color: 'var(--accent)' }}
                        >
                            ← Kembali ke beranda
                        </a>
                    </>
                )}
            </div>
        </div>
    );
}
